import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  getDetailData,
  getVideoImageUrl,
  getCiDecoId,
} from '../../../../../../../api';
import { ROUTE, CONTENT_TYPE, PATH } from '../../../../../../../constants';
import { formatNameText } from '../../../../../../../utils/TextHelper';
import './CategoryItem.css';
import { scrollToTop } from '../../../../../../../utils';

class CategoryItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      decoId: getCiDecoId(),
    };
  }

  getThumbImage(type, id) {
    if (type === CONTENT_TYPE.VIDEO) {
      return getVideoImageUrl(id);
    }
    return `${PATH.PHOTO}${id}.jpg`;
  }

  render() {
    const { decoId } = this.state;
    const { id, categoryId, msgCount } = this.props;
    const detailData = getDetailData(id);
    const { type } = detailData;
    const anyMsg = msgCount && msgCount > 0;

    return (
      <Link
        className="category-item"
        to={`${ROUTE.DETAIL}/${categoryId}/${id}`}
        onClick={scrollToTop}
      >
        <div className="category-item-in">
          <div className="ci-img-wrap">
            {anyMsg && (
              <img
                className="ci-msg-deco"
                src={`${PATH.IMG}deco/cd-${decoId}.png`}
                alt=""
              />
            )}
            <div className="ci-thumb-wrap">
              <img
                className="category-thumb"
                src={this.getThumbImage(type, id)}
                alt={`Detail: ${detailData.name}`}
              />
            </div>
          </div>
          <div className="ci-info">
            <img
              className="ci-info-ico"
              src={`${PATH.IMG}deco/ico-type-${type}.png`}
              alt=""
            />

            <div className={`ci-info-name ${anyMsg ? 'count' : ''}`}>
              {formatNameText(detailData.name)}
            </div>
            {anyMsg && (
              <div className="ci-msg-count">
                <img
                  className="bg"
                  src={`${PATH.IMG}deco/msg-count.png`}
                  alt=""
                />
                <div className="number">{msgCount}</div>
              </div>
            )}
          </div>
        </div>
      </Link>
    );
  }
}

export default CategoryItem;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/CategoryList/CategoryItems/CategoryItem/CategoryItem.js